import { render } from "./SectionList.vue?vue&type=template&id=38815630&scoped=true"
import script from "./SectionList.vue?vue&type=script&lang=js"
export * from "./SectionList.vue?vue&type=script&lang=js"

import "./SectionList.vue?vue&type=style&index=0&id=38815630&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38815630"]])

export default __exports__